import {
 Box,
 Button,
 Center,
 FormControl,
 Input,
 InputGroup,
 InputLeftElement,
 InputRightElement,
 VStack,
 Text,
 Heading,
 IconButton,
 useToast,
} from "@chakra-ui/react";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext/AuthContextProvider";

const Login = () => {
 const toast = useToast();
 const navigate = useNavigate();
 const { setIsAuth } = React.useContext(AuthContext);
 const [showPassword, setShowPassword] = useState(false);
 const [loginData, setLoginData] = useState({
  mail_id: "",
  password: "",
 });

 const togglePassword = () => setShowPassword(!showPassword);

 const handleChange = (e) => {
  const { name, value } = e.target;
  setLoginData((prev) => ({ ...prev, [name]: value }));
 };

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
   const res = await axios.post(
    `https://admission-backend-theta.vercel.app/api/user/login`,
    loginData
   );
   const userDataString = JSON.stringify(res.data.user[0].firstname);
   if (res.status === 200) {
    setIsAuth(true);
    localStorage.setItem("user", userDataString);
    localStorage.setItem("isAuth", true);
    toast({
     title: "User",
     description: "Login successfully.",
     status: "success",
     duration: 4000,
     isClosable: true,
    });
    navigate("/");
   }
  } catch (err) {
   toast({
    title: "Login Failed",
    description: "Invalid credentials",
    status: "error",
    duration: 4000,
    isClosable: true,
   });
  }
 };

 return (
  <Box bgGradient="linear(to-t, #e0f7fa, #ffffff)" minH="100vh" py={10}>
   <Center>
    <Box bg="white" p={8} rounded="2xl" boxShadow="lg" width={["90%", "400px"]}>
     <Center mb={4}>
      <Box bg="gray.100" p={3} borderRadius="lg" boxShadow="md">
       <FaLock size={24} />
      </Box>
     </Center>

     <Heading textAlign="center" fontSize="xl" mb={2}>
      Sign in with email
     </Heading>
     <Text textAlign="center" fontSize="sm" color="gray.600" mb={6}>
      Empowering your journey to the right college—smart, simple, and
      personalized. 🚀
     </Text>

     <form onSubmit={handleSubmit}>
      <VStack spacing={4}>
       <FormControl isRequired>
        <InputGroup>
         <InputLeftElement pointerEvents="none">
          <FaEnvelope color="gray.400" />
         </InputLeftElement>
         <Input
          name="mail_id"
          value={loginData.mail_id}
          onChange={handleChange}
          placeholder="Email"
          type="email"
          bg="gray.100"
         />
        </InputGroup>
       </FormControl>

       <FormControl isRequired>
        <InputGroup>
         <InputLeftElement pointerEvents="none">
          <FaLock color="gray.400" />
         </InputLeftElement>
         <Input
          type={showPassword ? "text" : "password"}
          name="password"
          value={loginData.password}
          onChange={handleChange}
          placeholder="Password"
          bg="gray.100"
         />
         <InputRightElement>
          <IconButton
           variant="ghost"
           size="sm"
           icon={showPassword ? <FaEyeSlash /> : <FaEye />}
           onClick={togglePassword}
           aria-label="Toggle Password Visibility"
          />
         </InputRightElement>
        </InputGroup>
       </FormControl>

       <Box width="100%" textAlign="right" fontSize="sm">
        <Link to="/forgot-password">Forgot password?</Link>
       </Box>

       <Button
        type="submit"
        width="100%"
        mt={2}
        colorScheme="blackAlpha"
        bg="#01B4EC"
        color="white"
        _hover={{ bg: "gray.800" }}
        borderRadius="lg"
        py={6}
       >
        Get Started
       </Button>
      </VStack>
     </form>

     <Text textAlign="center" fontSize="sm" mt={6} color="gray.500">
      🚀 Don't have an account?{" "}
      <Link to="/register" style={{ color: "#3182CE", fontWeight: "500" }}>
       Join Admission Possibility today!
      </Link>
     </Text>
    </Box>
   </Center>
  </Box>
 );
};

export default Login;

// import {
//  Box,
//  Button,
//  Center,
//  FormControl,
//  FormLabel,
//  Heading,
//  Input,
//  Text,
//  useToast,
// } from "@chakra-ui/react";
// import axios from "axios";
// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../AuthContext/AuthContextProvider";

// const Login = () => {
//  const toast = useToast();
//  const navigate = useNavigate();
//  const { isAuth, setIsAuth, toggleAuth } = React.useContext(AuthContext);
//  const [loginData, setLoginData] = useState({
//   mail_id: "",
//   password: "",
//  });

//  const loginUser = (loginData) => {
//   axios
//    // .post(`https://admission-backend-theta.vercel.app/api/user/login`, loginData)
//    .post(`https://admission-backend-theta.vercel.app/api/user/login`, loginData)
//    .then((res) => {
//     console.log("res:", res.data);
//     const userDataString = JSON.stringify(res.data.user[0].firstname);
//     if (res.status === 200) {
//      setIsAuth(true);
//      localStorage.setItem("user", userDataString);
//      localStorage.setItem("isAuth", true);

//      toast({
//       title: "User",
//       description: "Login successfully.",
//       status: "success",
//       duration: 4000, // Duration in milliseconds
//       isClosable: true, // Allow users to close the toast manually
//      });
//      navigate("/");
//     }
//    });
//  };
//  console.log("isAuth in login:", isAuth);

//  const handleSubmit = (event) => {
//   event.preventDefault();
//   console.log("clicked handle submit");
//   loginUser(loginData);
//   console.log(loginData);
//  };

//  const handleChange = (event) => {
//   const { name, value } = event.target;
//   setLoginData((prev) => ({ ...prev, [name]: value }));
//  };

//  return (
//   <Box bg={"rgb(151,162,226)"}>
//    <Box
//     width={"100%"}
//     height={"80vh"}
//     marginTop={"16vh"}
//     display={"flex"}
//     alignItems={"center"}
//     justifyContent={"center"}
//    >
//     <Box
//      width={"40%"}
//      p="10"
//      bg="#ffff"
//      borderRadius={"12px"}
//      boxShadow="0px 3px 8px rgba(0, 0, 0, 0.24)"
//     >
//      <Heading fontSize={"1.5rem"} textAlign={"center"} mb={"5"}>
//       Login Here
//      </Heading>
//      <form onSubmit={handleSubmit}>
//       <FormControl>
//        <FormLabel>Mail ID</FormLabel>
//        <Input
//         name="mail_id"
//         value={loginData.mail_id}
//         onChange={handleChange}
//         placeholder="Enter your mail id"
//        />
//       </FormControl>
//       <FormControl>
//        <FormLabel>Password</FormLabel>
//        <Input
//         type="password"
//         name="password"
//         value={loginData.password}
//         onChange={handleChange}
//         placeholder="Enter your password"
//        />
//       </FormControl>

//       <Box textAlign={"center"} mt={"5"}>
//        {" "}
//  <Link to="/register">
//   <Text color={"blue"}>Don't have account click me to Register ⬇</Text>
//  </Link>
//       </Box>
//       <Center>
//        {" "}
//        <Input
//         mt={"5"}
//         margin={"auto"}
//         width={"80%"}
//         border={"2px solid #01B4EC"}
//         _hover={{ backgroundColor: "#01B4EC", color: "white" }}
//         type="submit"
//        />
//       </Center>
//      </form>
//     </Box>
//    </Box>
//   </Box>
//  );
// };

// export default Login;
